<a [routerLink]="route" class="flex items-center user-menu-item text-gray-700 px-12 py-4 lg:px-4 lg:py-2 lg:block lg:text-center">
  <img *ngIf="icon" alt [src]="icon" class="lg:hidden inline mr-3" width="38" />
  <span>{{ title }}</span>
</a>
